import { render } from "./SideMenuFilesCom.vue?vue&type=template&id=58e9eb66&scoped=true"
import script from "./SideMenuFilesCom.vue?vue&type=script&lang=js"
export * from "./SideMenuFilesCom.vue?vue&type=script&lang=js"

import "@/assets/process_steps.css?vue&type=style&index=0&id=58e9eb66&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e9eb66"]])

export default __exports__